import {
	ref,
	computed,
} from 'vue';
import { useStore } from 'vuex';

const labels = {
	categoryName: ref(''),
	reset: ref(''),
	facetsHeading: ref(''),
	applyFilters: ref(''),
	loadingProducts: ref(''),
	additionalInfo: ref(''),
	showMore: ref(''),
	showLess: ref(''),
	searchPlaceholderText: ref(''),
	noShortCodeMatch: ref(''),
	viewAllLabel: ref(''),
};

export default function useProductListLabels(props) {
	if (props) {
		labels.categoryName.value = props.vm.CurrentPage.CategoryName;
		labels.reset.value = props.vm.CurrentPage.ResetFiltersLabel;
		labels.facetsHeading.value = props.vm.CurrentPage.FacetsHeading;
		labels.applyFilters.value = props.vm.CurrentPage.ApplyFiltersLabel;
		labels.loadingProducts.value = props.vm.CurrentPage.LoadingProductsLabel;
		labels.additionalInfo.value = props.vm.CurrentPage.AdditionalInformation;
		labels.showMore.value = props.vm.CurrentPage.ShowMoreAdditionalInformationLabel;
		labels.showLess.value = props.vm.CurrentPage.ShowLessAdditionalInformationLabel;
		labels.searchPlaceholderText.value = props.vm.BaseViewModel.SearchPlaceholderText;
		labels.noShortCodeMatch.value = props.vm.CurrentPage.NoShortCodeMatch;
		labels.viewAllLabel.value = props.vm.BaseViewModel.ViewAllLabel;
	}

	const store = useStore();
	const products = computed(() => store.getters.getResults);
	const getApplyText = computed(() => labels.applyFilters?.value.replace('{n}', products.value.length));

	return {
		labels,
		getApplyText,
	}
}
